import styled, { css } from "styled-components";

const TitleWrapper = styled.div`
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "fit-content")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "38px")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "bold")};
  color: ${(props) => (props.color ? props.color : "#0b1936")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  text-align: ${(props) => (props.textAlign ? props.textAlign : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};

  @media (max-width: 1023.5px) {
    max-width: ${(props) => (props.maxWidthMd ? props.maxWidthMd : "")};
    text-align: ${(props) => (props.textAlignMd ? props.textAlignMd : "")};
    margin-bottom: ${(props) =>
      props.marginBottomMd ? props.marginBottomMd : ""};
  }
  @media (max-width: 767.5px) {
    font-size: ${(props) => (props.fontSizeSm ? props.fontSizeSm : "")};
    text-align: ${(props) => (props.textAlignSm ? props.textAlignSm : "")};
  }

  ${(props) =>
    props.secondaryTitle &&
    css`
      color: #222222;
    `}
`;

export default TitleWrapper;
